























































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import { AxiosStatic } from "axios";
import IResource from "@/interfaces/IResource";
import ICustomfield from "@/interfaces/ICustomfield";
import EditCustomfieldModal from "@/components/EditCustomfieldModal.vue";
import CreateCustomfieldModal from "@/components/CreateCustomfieldModal.vue";
import draggable from 'vuedraggable'
import UpgradeModal from "@/components/UpgradeModal.vue";
import IPlan from "@/interfaces/IPlan";

@Component({
	components: {
		CreateCustomfieldModal,
		EditCustomfieldModal,
		UpgradeModal,
		draggable
	}
})
export default class SettingsCustomfields extends Vue {

	public $http!: AxiosStatic;

	@Prop({
		required: true,
		type: Number
	})
	public resourceid!: number;

	public customfields: ICustomfield[] | null = null;

	public showError: boolean = false;
	public isLoading: boolean = false;
	public isSorting: boolean = false;

	get resource(): IResource | null {
		if (this.$store.state.resources) {
			let filtered = this.$store.state.resources.filter((r: IResource) => r.id == this.resourceid);
			if (filtered.length > 0) {
				return filtered[0];
			}
		}
		return null;
	}

	get storeCustomfields(): ICustomfield[] | null {
		if (this.resource) {
			return this.resource.customfields;
		}
		return null;
	}

	get activeplan(): IPlan {
		return this.$store.state.activeplan;
	}

	@Watch('storeCustomfields', { immediate: true })
	public watchStoreCustomfields() {
		this.customfields = this.storeCustomfields;
	}

	public mounted() {
		this.showError = false;
		this.isLoading = false;

		this.$store.dispatch('loadOrganisation', {root: true});
	}

	public onListChange() {
		if (this.customfields) {
			this.isSorting = true;
			let ids = this.customfields.map((field: ICustomfield) => field.id);
			this.$http.post('/private/resource/' + this.resourceid + '/customfields/sort', { order: ids }).then(() => {
				this.$store.dispatch('loadResources', {root: true}).finally(() => {
					this.isSorting = false;
				});
			}).catch(() => {
				this.isSorting = false;
			});
		}
	}

	public deleteCustomfield(id: number) {
		if (confirm('Dieses Datenfeld wirklich löschen?')) {
			this.isLoading = true;
			this.$http.delete('/private/customfield/' + id).then(() => {
				this.isLoading = false;
				this.$store.dispatch('loadResources', {root: true});
			}).catch(() => {
				this.isLoading = false;
				this.showError = true;
			});
		}
	}

}
